import React from 'react';
import "../../scss/Footer.scss";

const Footer = () => {
  return (
    <div className='footer-bar'>
      <p>This app is developed by <a href="https://github.com/Mohamed-C0DE" rel="noopener noreferrer" target="_blank">Mohamed Ali</a>, <a href="https://github.com/joshitrigun" rel="noopener noreferrer" target="_blank">Trigun Joshi</a> and <a href="https://github.com/RAtul14ApriL" rel="noopener noreferrer" target="_blank">Ratul Hefzul Bari</a>.</p>
    </div>
  )
}

export default Footer;